// Track 1 — Soft-gate landing page for non-Rapha users hitting
// rapha.aero.chat. Not a 403 — they get a friendly explanation + two CTAs
// (sign in as Rapha, or continue to aero.chat).

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../theme';

export default function RaphaMembersOnly() {
  const { t } = useTranslation('rapha-gate');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        backgroundColor: colors.bg,
        background: colors.gradHero,
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: '100%',
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          backgroundColor: colors.surface,
          border: `1px solid ${colors.border}`,
          boxShadow: `0 0 0 1px ${colors.brandShadow}, 0 20px 64px rgba(0,0,0,0.4)`,
        }}
      >
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 600,
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: colors.brand,
            mb: 1.5,
          }}
        >
          {t('overline')}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            fontWeight: 700,
            color: colors.text,
            lineHeight: 1.15,
            mb: 2,
          }}
        >
          {t('title')}
        </Typography>
        <Typography sx={{ fontSize: '1rem', color: colors.textMuted, lineHeight: 1.6, mb: 4 }}>
          {t('body')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Button
            variant="contained"
            href="/login"
            sx={{
              px: 3,
              py: 1.5,
              backgroundColor: colors.brand,
              color: colors.textInverse,
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': { backgroundColor: colors.brandBright },
            }}
          >
            {t('ctaSignIn')}
          </Button>
          <Button
            variant="text"
            href="https://aero.chat"
            sx={{
              color: colors.textMuted,
              textTransform: 'none',
              fontSize: '0.875rem',
              '&:hover': { color: colors.text },
            }}
          >
            {t('ctaContinueAero')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
